<div class="p-grid container_user">
    <user-cdsid class="p-col-12"></user-cdsid>
	<user-location class="p-col-12"></user-location>
</div>
